// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"99aadfc8","551":"465f5c67","624":"71e7655f","842":"cd2b5f44"}[chunkId] + ".chunk.js";
};